// @ts-ignore
import events from 'events-bus';

import Constants from '../Constants';

export default class Cart {
  static onCartGet(onSuccess: any, onError: any) {
    if (onSuccess) {
      events.on(Constants.EVENT.CART.GET_CART_SUCCESS, onSuccess);
    }

    if (onError) {
      events.on(Constants.EVENT.CART.GET_CART_FAILURE, onError);
    }
  }

  static onSetArticleQuantity(onSuccess: any, onError: any) {
    if (onSuccess) {
      events.on(Constants.EVENT.CART.ADD_TO_CART_SUCCESS, onSuccess);
    }

    if (onError) {
      events.on(Constants.EVENT.CART.ADD_TO_CART_FAILURE, onError);
    }
  }

  static setArticleQuantity(articleId: number, amount: number, trigger: any) {
    events.post(Constants.EVENT.CART.ADD_TO_CART, {
      articleId: articleId,
      quantity: amount,
      trigger: trigger,
      status: 'ADDED',
    });
  }

  static getCart() {
    events.post(Constants.EVENT.CART.GET_CART, {});
  }

  static notifyQuantityChange(onSuccess: any) {
    events.on(Constants.EVENT.CART.UPDATE_ADOBE, onSuccess);
  }
}
